import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-sm border border-[hsl(var(--border-hairline))] bg-[hsl(var(--panel))] px-3 py-2 text-[13px] text-[hsl(var(--fg-cream))] transition-colors duration-200",
          "placeholder:text-[hsl(var(--fg-muted))]",
          "focus-visible:outline-none focus-visible:border-[hsl(var(--accent-brick))] focus-visible:ring-1 focus-visible:ring-[hsl(var(--accent-brick))]",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[hsl(var(--fg-cream))]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
